import Axios from "../helper/appConfig";

export const getDatasAccService = async (payload) => {
  return Axios.post("api/common/contacts/filter", payload);
};

export const patchAccDataService = async (endpoint,payload) => {
  return Axios.patch("api/" + endpoint, payload);
};

export const patchMemberAccDataService = async (endpoint,payload) => {
  return Axios.patch("api/members" + endpoint, payload);
};

export const patchProspectAccDataService = async (endpoint, payload) => {
  return Axios.patch("api/prospects" + endpoint, payload);
};
